import { render } from "./SectionNavigationProfile.vue?vue&type=template&id=6be31bba&scoped=true"
import script from "./SectionNavigationProfile.vue?vue&type=script&lang=js"
export * from "./SectionNavigationProfile.vue?vue&type=script&lang=js"

import "./SectionNavigationProfile.vue?vue&type=style&index=0&id=6be31bba&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be31bba"]])

export default __exports__